import { drawMindMap } from './draw.js';
import { layout } from './layout.js';
export const mindMap = {
    layout,
    drawInEdgeless: drawMindMap,
};
//# sourceMappingURL=index.js.map